<template>
<div :class="unclickable">
        <div class="sorgente_luminosa_p maiuscoletto_opaco_piccolo">
                                   <p class="paese_title_paese_select paese_it">{{ paese }}</p>
                                   <p class="paese_title_paese_select paese_eu"> COUNTRY </p>
         </div>
     <v-select
          v-model="PAESE"
          class="select-group-vue"
          :items="PAESI"
          item-value="paese_text"
          item-text="paese"
          v-on:change="modifica_paese()"
        />
  </div>
</template>
<script>
import class_check_language from '../classes/class_check_language'
export default {
    name : 'paeseselect',
    data() {
        return {

            SORGENTE : '', 
            PAESI : [
               {'paese' : 'Europe', 'paese_text':'EU'},
               {'paese' : 'Usa e Canada', 'paese_text':'UL'}
            ],
            PAESE : 'EU',
            paese : 'PAESE',
            unclickable:'',
            
        }
    },
  mounted() {
        let l = new class_check_language();
        if (!l.is_italian) {
            this.paese = 'COUNTRY';

        }
            let listino = this.$store.state.product.codice_listino;
            if (listino == '1'){
                this.PAESE = 'EU';
            }else{
                this.PAESE = 'UL';
            }
            if (listino == ''){
                this.PAESE = 'EU';
            }
            if (listino == undefined){
                this.PAESE = 'EU';
            }
                this.logged_in = window.descrizione.logged_in;
        this.unclickable = 'clickable';
        if (this.logged_in){
            this.unclickable = 'unclickable';

        }
  },
  methods: {
    modifica_paese() {
        this.$store.commit('selected_paese', this.PAESE)
    }
  }
}
</script>
<style scoped>
.paese_title_paese_select{
    margin-bottom: 0px;
    padding-bottom: 0px;
}
.unclickable{
    display: none;
}
html[lang="en-US"]  .paese_it{
display: none;
}
html[lang="it-IT"]  .paese_eu{
display: none;
}
</style>